PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'

module.exports = class RenameBoardView extends View
  viewTitleKey: 'rename board'

  events:
    'click .js-rename-board': 'rename'
    'submit form': 'rename'

  render: (e) ->
    data = {}
    data.boardName = @model.get('name')

    @$el.html(
      templates.fill(
        'popover_rename_board',
        data
      )
    )
    @

  rename: (e) ->
    Util.stop(e)
    $boardName = @$('.js-board-name')
    val = $boardName.val().trim()
    if val == ''
      $boardName.focus().select()
      return
    track("Board", "Successfully Rename Board")
    @model.update("name", val)
    PopOver.hide()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/rename-board-view.coffee